export default "__VITE_ASSET__BPe1W6UZ__"